var ctrlPressed = false;
var altPressed = false;
var shiftPressed = false;
var wPressed = false;
var aPressed = false;
var iPressed = false;

document.onkeydown = function keyDown(e)
{
	var keyCode;

	// ie or mozilla
	keyCode = (document.all) ? window.event.keyCode : e.which;

	if (keyCode == 18)
	{
		altPressed = true;
	}
	if (keyCode == 17)
	{
		ctrlPressed = true;
	}
	if (keyCode == 16)
	{
		shiftPressed = true;
	}
	if (keyCode == 87)   // W
	{
		wPressed = true;
	}
	if (keyCode == 65)   // A
	{
		aPressed = true;
	}
	if (keyCode == 73)   // I
	{
		iPressed = true;
	}

	// self.status = "ALT=" + altPressed + " CTRL=" + ctrlPressed + " SHIFT=" +
	// shiftPressed + " w=" + wPressed;
	return true;
};

document.onkeyup = function keyUp(e)
{
	var keyCode;

	// ie or mozilla
	keyCode = (document.all) ? window.event.keyCode : e.which;

	if (keyCode == 18)
	{
		altPressed = false;
	}
	if (keyCode == 17)
	{
		ctrlPressed = false;
	}
	if (keyCode == 16)
	{
		shiftPressed = false;
	}
	if (keyCode == 87)   // W
	{
		wPressed = false;
	}
 	if (keyCode == 65)   // A
	{
		aPressed = false;
	}
 	if (keyCode == 73)   // I
	{
		iPressed = false;
	}

	// self.status = "ALT=" + altPressed + " CTRL=" + ctrlPressed + " SHIFT=" +
	// shiftPressed + " w=" + wPressed;
	return true;
};
